import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ReportProvider } from 'src/app/providers';
import { ReportService, UserService, ToasterService } from 'src/app/services';
import { CreditPurchasePopupComponent } from '../../report';

@Component({
  selector: 'app-transactions-history',
  templateUrl: './transactions-history.component.html',
  styleUrls: ['./transactions-history.component.scss']
})
export class TransactionsHistoryComponent implements OnInit {

  transactionHistory: Array<any> = [];
  totalRecords: number = 0;
  currentPageNumber: number = 1;

  constructor(private _location: Location, public userService: UserService,
    private modalService: BsModalService,
    private toastr: ToasterService,
    private reportProvider: ReportProvider,
    public reportService: ReportService) { }

  ngOnInit(): void {
    this.getTransactionHistory();
  }

  /**
   * @description gettransaction history
   */
  getTransactionHistory() {
    this.reportProvider.getBillingTransactions(this.currentPageNumber).subscribe(resp => {
      if (resp.success) {
        this.transactionHistory = resp.result.items;
        this.totalRecords = resp.result.totalItems;
      } else {
        this.toastr.error(resp.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description pagination event
   */
  pageChanged(event: PageChangedEvent): void {
    this.currentPageNumber = event.page;
    this.getTransactionHistory();
  }

  /**
   * @description go back
   */
  goBack() {
    this._location.back();
  }

  /**
   * @description for open credit purchase popup
   */
  openCreditPurchasePopup() {
    this.modalService.show(CreditPurchasePopupComponent, Object.assign({
      initialState: {
        reportId: ''
      }
    }, { class: 'modal-lg modal-dialog-centered' }));
  }

}
